<template>
  <el-row>
    <!-- <hic-patient-panel ref="patientPanel" :id="entity.patientCode" isEditor @loaded="patientLoaded" @saved="patientSaved" @canceled="close"></hic-patient-panel> -->
    <!-- <br/> -->
    <el-form class="left" ref="editor" :rules="rules" :inline="true" :model="submitInfo" label-width="9rem">
      <el-col :span="6">
        <el-form-item label="姓名：">
          <el-input class="" v-model="submitInfo.xingming" placeholder="请输入患者姓名" size="small" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="性别：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.xingbie"
            placeholder="请选择性别"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="证件类型：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.zjlx"
            placeholder="请选择证件类型"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="证件号码：">
          <el-input class="" v-model="submitInfo.xingming" placeholder="请输入证件号码" size="small" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item label="出生日期：">
          <el-date-picker size="small" value-format="yyyy-MM-dd" class="f-w" v-model="submitInfo.csrq" type="date"
            placeholder="请选择出生日期"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="年龄：">
          <el-input class="" v-model="submitInfo.nianling" placeholder="请输入年龄" size="small" clearable></el-input>
          <span class="slc">岁</span>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="新生儿出生体重：">
          <el-input class="" v-model="submitInfo.tizhong" placeholder="请输入生儿出生体重" size="small" clearable></el-input>
          <span class="slc">克</span>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="新生儿入院体重：">
          <el-input class="" v-model="submitInfo.rytizhong" placeholder="请输入生儿入院体重" size="small" clearable></el-input>
          <span class="slc">克</span>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="国籍：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.guoji"
            placeholder="请选择国籍"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="民族：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.minzu"
            placeholder="请选择民族"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="婚姻状况：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.hunyin"
            placeholder="请选择婚姻状况"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="职业：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.zhiye"
            placeholder="请选择职业"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="联系电话：">
          <el-input class="" v-model="submitInfo.lxdh" placeholder="请输入联系电话" size="small" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="出生地：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.csd"
            placeholder="请选择省市区"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="籍贯：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.jg" placeholder="请选择省市区"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="户口地址：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.hukoudz" placeholder="请选择省市区"
            class="w220 mr10"></hic-dict-selector>
          <el-input class="" v-model="submitInfo.xiangxidizhi" placeholder="详细地址" size="small" clearable
            style="width:27.5rem"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="邮编：">
          <el-input class="" v-model="submitInfo.youbian1" placeholder="请输入邮编" size="small" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="现住址：">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.xianzhuzhi" placeholder="请选择省市区"
            class="w220 mr10"></hic-dict-selector>
          <el-input class="" v-model="submitInfo.xiangxidizhi2" placeholder="详细地址" size="small" clearable
            style="width:27.5rem"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="邮编：">
          <el-input class="" v-model="submitInfo.youbian2" placeholder="请输入邮编" size="small" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="工作单位：">
          <el-input style="width:42rem;" v-model="submitInfo.work" placeholder="请输入工作单位名称" size="small"
            clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="邮编：">
          <el-input class="" v-model="submitInfo.youbian3" placeholder="请输入邮编" size="small" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="单位电话：">
          <el-input class="" v-model="submitInfo.workdh" placeholder="请输入单位电话" size="small" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-divider></el-divider>
      </el-col>

      <el-col :span="24">
        <el-row type="flex" align="middle">
          <h3 class="mr10">联系人信息</h3><el-button type="primary" icon="el-icon-plus" circle size="small"></el-button>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-row class="mt10">
          <el-col :span="6">
            <el-form-item label="联系人：">
              <el-input class="" v-model="submitInfo.lxr" placeholder="请输入联系人姓名" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="关系：">
              <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.fufeityep"
                placeholder="请选择与患者的关系"></hic-dict-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电话：">
              <el-input class="" v-model="submitInfo.lxrdh" placeholder="请输入联系人电话" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="地址：">
              <el-input class="" v-model="submitInfo.lxrdz" placeholder="请输入联系人地址" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-col>
      

      <el-col :span="24">
        <el-divider></el-divider>
      </el-col>

      <el-col :span="6">
        <el-form-item label="医疗付费方式：" :prop="fufeityep">
          <hic-dict-selector dict-type="InsuranceType" v-model="submitInfo.fufeityep"
            placeholder="请选择医疗付费方式"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="入院途径：">
          <hic-dict-selector dict-type="IpComeFrom" v-model="submitInfo.comeFrom"
            placeholder="请选择住院类型"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="入院时间：">
          <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" class="" v-model="submitInfo.startDate"
            type="datetime" placeholder="请选择入院时间"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="入院科室：" :prop="originalDeptCode">
          <hic-dept-selector class="f-w" v-model="submitInfo.originalDeptCode" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="入院病区：" :prop="originalAreaCode">
          <hic-dict-selector dict-type="IpWard" v-model="submitInfo.originalAreaCode"
            placeholder="请选择入院病区"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="转科科别：">
          <hic-dept-selector class="" v-model="submitInfo.originalDeptCode" />

          <!-- <el-input class="" v-model="submitInfo.dosage" placeholder="请输入" size="small" clearable></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="出院时间：">
          <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" class="f-w" v-model="submitInfo.endDate"
            type="datetime" placeholder="请选择入院时间"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="出院科室：">
          <hic-dept-selector :is-ip="true" class="f-w" v-model="submitInfo.deptCode" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="出院病区：">
          <hic-dict-selector dict-type="IpWard" v-model="submitInfo.wardCode" placeholder="请选择住院类型"></hic-dict-selector>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="实际住院天数：">
          <el-input class="" v-model="submitInfo.dosage" placeholder="请输入" size="small" clearable></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="6">
     <el-form-item label="药物过敏：">
      <el-radio-group v-model="submitInfo.ipType">
        <el-radio label="无" size="mini">无</el-radio>
        <el-radio label="有" size="mini">有</el-radio>
      </el-radio-group>
     </el-form-item>
   </el-col>
   <el-col :span="6">
     <el-form-item label="过敏药物：">
      <el-input class="" v-model="submitInfo.dosage" placeholder="请输入" size="small" clearable></el-input>
     </el-form-item>
   </el-col> -->
      <el-col :span="24">
        <el-form-item label="死亡患者尸检：">
          <el-radio-group v-model="submitInfo.ipType">
            <el-radio label="是" size="mini">是</el-radio>
            <el-radio label="否" size="mini">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="22" class="right" style="">
        <el-button @click="submit" type="primary" size="small" icon="el-icon-edit">提交</el-button>
      </el-col>
      <!-- <el-col :span="24">
     <el-form-item label="血        型：">
       <hic-dict-selector class="einputw mr10" dict-type="IpStayType" v-model="submitInfo.stayType" placeholder="请选择住院类型"></hic-dict-selector>
       <hic-dict-selector class="einputw" dict-type="IpStayType" v-model="submitInfo.stayType" placeholder="请选择住院类型"></hic-dict-selector>
     </el-form-item>
   </el-col> -->
    </el-form>
    <!-- <el-row>
    病案首页
    {{entity}}
  </el-row> -->
  </el-row>



</template>
<script>
import api from "../api"
import { mapGetters } from "sw-hic";
export default {
  props: {
    entity: Object,
  },
  data() {
    return {
      showFee: false,
      submitInfo: {},
      patientCode: null,
      rules: {
        originalDeptCode: [{ required: true, message: "请选择科室编码", trigger: "change" }],
        originalAreaCode: [{ required: true, message: "请选择入院病区", trigger: "change" }],
        fufeityep: [{ required: true, message: "请选择医疗付费方式", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "user"]),
  },
  watch: {
    entity() {
      this.load();
    },
  },
  created() {
    // this.load();
  },
  methods: {
    load() {
      // this.$set(this.submitInfo,'ipType','')
      // this.$set(this.submitInfo,'startDate','')
      // this.$set(this.submitInfo,'endDate','')
      // this.$utils.Obj.propertyCopy(this.entity, this.submitInfo) //为了使用raido能够正常使用，需要重置数据的值
    },
    open() {

    },
    close() {
      this.$emit("update:visible", false);
    },
    patientLoaded(patient) {
      // this.submitInfo.patientName = patient.name;
      // this.submitInfo.patientGender = patient.gender;
      // this.submitInfo.patientAge = this.$utils.Fmt.age(patient.birthday);
      // this.submitInfo.insuranceType = patient.insuranceType;
      // this.submitInfo.insuranceNo = patient.insuranceNo;
      // if (!this.submitInfo.ipType && patient.insuranceNo) {
      //   this.submitInfo.ipType = this.Enum.IpType.医保;
      // } else {
      //   this.submitInfo.ipType = this.Enum.IpType.自费;
      // }
      this.showFee = true
    },
    submit() {
      this.$refs.patientPanel.save()
    },
    patientSaved() {
      // this.patientLoaded(patient);
      console.log('this.submitInfo===', this.submitInfo)
      api.Hospitalization.save(this.submitInfo)
        .then((res) => {
          this.$message.success("保存成功！");
          // this.$emit("update:visible", false);
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
}
</script>